<script setup>
import { provide, reactive } from 'vue'
import MainNav from '@/components/MainNav.vue'
import MainFooter from '@/components/MainFooter.vue'
import { PrimeIcons } from '@primevue/core/api'
import router from '@/router'
import barkerAuth from '@/auth'

const navbarItems = reactive([
    {
        label: 'Home',
        icon: PrimeIcons.HOME,
        visible: false,
        command: () => {
          router.push({name: 'home'})
        },
    },
    {
        label: 'Account',
        icon: PrimeIcons.USER,
        visible: false,
        command: () => {
          router.push({name: 'account'})
        },
    },
    {
        label: 'Help',
        icon: PrimeIcons.QUESTION_CIRCLE,
        command: () => {
          router.push({name: 'help'})
        },
    },
    {
        label: 'Log Out',
        icon: PrimeIcons.SIGN_OUT,
        command: () => {
          router.push({name: 'logout', query:{action: 'logout'}})
        },
        visible: false,
    }
])

navbarItems.AUTHENTICATED_ITEMS_ = ['home', 'account', 'log out']

navbarItems.isLoggedIn = false

navbarItems.visibility_ = function(x, value){
  if(typeof(x) != typeof([])){
    x = [x]
  }
  for(const i of x){
    for(const j of navbarItems){
      if(j.label.toLowerCase() == i.toLowerCase()){
        j.visible = value
      }
    }
  }
}

navbarItems.show_ = function(x){
  navbarItems.visibility_(x, true)
}

navbarItems.hide_ = function(x){
  navbarItems.visibility_(x, false)
}

navbarItems.login_ = function(){
  navbarItems.isLoggedIn = true
  navbarItems.show_(navbarItems.AUTHENTICATED_ITEMS_)
}

navbarItems.logout_ = function(){
  navbarItems.isLoggedIn = false
  navbarItems.hide_(navbarItems.AUTHENTICATED_ITEMS_)
}

if(barkerAuth.isLoggedIn()){
  navbarItems.login_()
}

provide('navbarItems', navbarItems)

</script>

<template>
  <div id="main_container">
    <main-nav />
    <router-view />
  </div>
  <main-footer />
  <Toast position="bottom-center" />
  <ConfirmDialog />
</template>

